import styles from './IconButton.module.scss';

import cx from 'classnames';
import React, { forwardRef } from 'react';

import { Icon, IIconProps } from 'components/Icon/Icon';
import { ICON_BUTTON_TEST_ID } from './IconButton.const';

interface IIconButtonProps
  extends Pick<IIconProps, 'type' | 'title'>,
    React.HTMLAttributes<HTMLButtonElement> {
  iconProps?: Omit<IIconProps, 'type' | 'title'>;
  children?: never;
}

export const IconButton = forwardRef<HTMLButtonElement, IIconButtonProps>(
  ({ className, type, title, iconProps, ...props }, ref) => {
    if (!type) return null;
    return (
      <button
        ref={ref}
        data-testid={ICON_BUTTON_TEST_ID.button}
        className={cx(styles.iconButton, type, className)}
        {...props}
      >
        <Icon {...{ title, type }} {...iconProps} />
      </button>
    );
  },
);
